import Vue from 'vue';
import { VTextField } from 'vuetify/lib';
import VCurrencyField from 'v-currency-field';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/my-extensions';
import './assets/fonts.css';
import 'regenerator-runtime/runtime';
import ScreenshotTicketPlugin from './plugins/screenshot-ticket';
import { installDiagnosticListeners } from './util/session-diagnostics';

Vue.prototype.console = console;

Vue.use(VCurrencyField, {
  locale: 'en-US',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true,
});

// Google Analytics
Vue.use(VueGtag, {
  config: { id: 'G-ELFYC6PW02' },
}, router);

// as per docs, for treeshaking
Vue.component('v-text-field', VTextField);

Vue.use(ScreenshotTicketPlugin);

Vue.config.productionTip = false;

// TKT-000697: record chunk/script load failures and uncaught errors so a county
// reporting a freeze leaves evidence behind. Adds listeners only - it cancels
// nothing and displaces no existing handler. See util/session-diagnostics.js.
installDiagnosticListeners();

document.addEventListener('dragstart', (e) => {
  const tag = e.target && e.target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA') {
    e.preventDefault();
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
